import { Outlet } from "react-router";

export default function Widget() {
   return (
       <Outlet />
   );
}
